import { getVolumeAucByClientType } from "../../service/api/SecurityService";
import { useChartLoading } from "../../service/Hooks/useChartLoading";
import useSelectedDomain from "../../service/Hooks/useSelectedDomain";
import ChartSkeleton from "../../skeleton/ChartSkeleton";
import DonutChart from "../DonutChart/DonutChart";

const formatAmountInThousands = (value) => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`;
  }
  return value.toLocaleString('fr-FR');
};

export const ChartDonutTitle = ({ selectedYear = null }) => {
  const selectedDomain = useSelectedDomain();
  const domainId = selectedDomain?.id;

  // On ne fait l'appel API que si domainId existe
  const { loading } = useChartLoading(
    async () => {
      if (!domainId) return null; //  empêche l'appel si undefined
      return getVolumeAucByClientType(domainId, selectedYear);
    },
    [domainId, selectedYear]
  );

  if (!domainId || loading) {
    return <ChartSkeleton delay="0.3s" />;
  }

  return (
    <DonutChart
      title="Titres par type de client"
      subtitle="Volume total AUC Bourse"
      fetchData={() => getVolumeAucByClientType(domainId, selectedYear)}
      valueKey="volumeAuc"
      formatValue={formatAmountInThousands}
      centerLabel="Volume AUC"
      selectedYear={selectedYear}
      delay="0.3s"
    />
  );
};
